<template>
  <v-layout
    justify-space-between
    align-center
    class="workspace-selection-header"
  >
    <v-tooltip bottom color="primary" open-delay="100">
      <template v-slot:activator="{ on }">
        <WeezieLogo
          class="back-button"
          v-on="on"
          @click="$router.push({ name: 'hub' })"
        />
      </template>
      <span style="font-size: 9px">{{ $t("BackToHub") }}</span>
    </v-tooltip>

    <div class="user-button-container">
      <user-avatar @toggleUser="toggleUserWindow" />
      <user-window
        right="10px"
        top="40px"
        v-if="userWindowOpen"
      />
    </div>
    <activate-two-authentication-dialog
      :open="opened2FArequired"
      @close="opened2FArequired = false "
      @activateAuthenticate="twoFactorAuthentication = true"
    />
  </v-layout>
</template>

<script>
import WeezieLogo from "@/assets/logos/WeezieLogo.vue";
import UserAvatar from "@/components/Home/NavBar/UserAvatar";
import UserWindow from "@/components/User/Navbar/UserWindow/UserWindow";
import { mixin as clickaway } from "vue-clickaway";
import ActivateTwoAuthenticationDialog from "@/components/User/Navbar/UserWindow/ActivateTwoAuthenticationDialog";
import { twoFactorAuthenticationMixin } from "@/mixins/twoFactorAuthenticationMixin";

export default {
  name: "WorkspaceSelectionHeader",

  components: {
    WeezieLogo,
    UserAvatar,
    UserWindow,
    ActivateTwoAuthenticationDialog
  },

  mixins: [clickaway, twoFactorAuthenticationMixin],

  data() {
    return {
      userWindowOpen: false,
    };
  },

  mounted() {
    setTimeout(() => {
      this.companie2FArequired();
    }, 500)
  },

  methods: {
    closeWindow() {
      this.userWindowOpen = false;
    },
    toggleUserWindow() {
      this.userWindowOpen = !this.userWindowOpen;
    }
  }
};
</script>

<style scoped>
.workspace-selection-header {
  height: 30px;
  width: 100%;
  box-shadow: 0 2px 4px 2px rgba(0, 0, 0, 0.3);
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  background: #ffffff;
  padding: 20px;
}

.back-button {
  cursor: pointer;
}

.user-button-container {
  cursor: pointer;
}

.workspace-selection-container .weezie-logo-management {
  width: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/Workspaces/Header.vue